import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { voucherSchema } from '../types';

export type AddVoucherMutationParams = {
	currency: string;
	count: number;
	deposit: number;
	wagering: number;
};

export const createAddVoucherMutation = () =>
	createAuthMutation({
		params: declareParams<AddVoucherMutationParams>(),
		request: {
			method: 'POST',
			url: '/voucher',
			body: (data) => data,
		},
		response: {
			contract: zodContract(voucherSchema),
		},
	});
